import { CircularProgress, Stack } from "@mui/material";

import { CreateShipmentFormDraftProvider } from "context/createShipmentFormDraftContext";

import { useAuthContext } from "../../../../hooks";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { VerticalDashboard } from "../VerticalDashboard";
import { HorizontalDashboard } from "./components/HorizontalDashboard";

export function Dashboard() {
  const { user } = useAuthContext();
  const useColumnLayout = useIsMobile({ maxWidth: 1300 });

  if (!user) {
    return (
      <Stack>
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <CreateShipmentFormDraftProvider>
      {useColumnLayout ? <VerticalDashboard /> : <HorizontalDashboard />}
    </CreateShipmentFormDraftProvider>
  );
}
